import { supabase } from '../lib/supabase';
import { addedDay } from './recent';

// Recently added (Part 3): what the tab needs besides the shelves, read with your own sign-in:
// the books Claude added for you (from its never-shared change record) and your import batches.
// (Location left this tab, Kristi Oct 30: it belongs with My books › Owned copies.)

type Row = Record<string, unknown>;

export interface Batch {
  id: string;
  name: string;
  on: string;
  /** import_kind: sheet, typed_list… (typed lists count as New books in Review). */
  kind?: string;
}

async function rows(q: PromiseLike<{ data: unknown; error: { message: string } | null }>): Promise<Row[]> {
  const { data, error } = await q;
  if (error) throw new Error(error.message);
  return (data as Row[] | null) ?? [];
}

export async function loadRecentFacts(): Promise<{ byClaude: Set<string>; batches: Batch[] }> {
  const db = supabase;
  if (!db) throw new Error('Not connected to a database.');
  const [added, batches] = await Promise.all([
    rows(db.from('claude_changes').select('book_id').eq('table_name', 'books').eq('action', 'add_row').is('undone_at', null).limit(5000)),
    rows(db.from('import_batches').select('id, name, kind, created_at').is('undone_at', null).order('created_at', { ascending: false })),
  ]);
  return {
    byClaude: new Set(added.map((r) => r.book_id as string).filter(Boolean)),
    batches: batches.map((b) => ({ id: b.id as string, name: (b.name as string) ?? 'Import', on: addedDay((b.created_at as string) ?? ''), kind: (b.kind as string) ?? undefined })),
  };
}
